module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_foilSilverHover-68d233e51111f0909f0602ceb60079b1.jpg";